import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../../utils/load-data-from-api';
import { assignOrderRelatedData } from '../../../../order/utils/assign-order-related-data';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { groupCurrentJourneys } from '../../../utils/group-current-journeys';
import { setJourneyList } from '../../../utils/set-journey-list';
export const loadCurrentMemberJourneys = async () => {
    if (!isMemberSignedIn()) {
        throw new Error('Cannot load active journeys when user is not signed in.');
    }
    const state = temporaryLoyaltyDomainStore.data.memberJourneys.current;
    await loadDataFromApi({
        api: ocapiClient.instance.v1.loyalty.members.journeys.getCurrent,
        state,
        cacheDuration: getCacheDuration('journeys'),
        onSuccess
    });
};
export const onSuccess = (response, cacheDuration) => {
    const { journeys, relatedData } = response;
    assignOrderRelatedData(relatedData, cacheDuration);
    setJourneyList(journeys);
    return { journeyGroups: groupCurrentJourneys(journeys) };
};
